const SWIPE_THRESHOLD = 75;
const TAB_SWIPE_ANIMATION_LENGTH = 260;

export const handleSwiping = (setOffset) => ({ deltaY, dir }) => {
  if (dir === 'Up' || dir === 'Down') {
    setOffset({ x: 0, y: -deltaY });
  }
};

export const handleSwiped = (
  setIsAnimating,
  setSlideIndex,
  slideIndex,
  setOffset,
  offset,
  boards,
  setDiscoverScrollPosition,
) => ({ dir }) => {
  // Reset exploreFeed's discoverscroll position which changes the top attribure of thie entire
  // element. This is a fix to help prevent misalignment due to interial scrolling in iOS
  setDiscoverScrollPosition(document.body.scrollTop || document.documentElement.scrollTop);

  // Represent swipe direction as a normalized positive or negative integer
  const directionNormalY = (offset.y / Math.abs(offset.y));

  const canSwipe = (dir === 'Down' && slideIndex > 0)
    || (dir === 'Up' && slideIndex < boards.length - 1);

  // Set the isAnimating boolean to enable tranistion animation for slides
  setIsAnimating(true);

  if (Math.abs(offset.y) > SWIPE_THRESHOLD && canSwipe) {
    // Set offset to full window height in correct direction, allowing slide to animate into place
    setOffset({
      x: 0,
      y: directionNormalY * window.innerHeight,
    });

    return setTimeout(
      () => {
        /**
         * After a slide transition is complete, we:
         *  1. Reset isAnimating to prevent a scroll when wwe change the slide content
         *  2. Set the new slide index
         *  3. Reset the offset to 0, 0 so the center slide can display the new content
         *
         * This should result in an "infinite" vertical carousel effect
         */
        setIsAnimating(false);
        setSlideIndex(
          Math.max(0, slideIndex - directionNormalY),
        );
        setOffset({ x: 0, y: 0 });
      },
      // This timeout length MUST be the same as, or greater than, the slide animatiobn duration
      TAB_SWIPE_ANIMATION_LENGTH,
    );
  }

  // If we havent returned yet it means we didnt hit a threshold or there is no slide,
  // snap back to original position
  return setOffset({ x: 0, y: 0 });
};
